import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ApiService } from '../../../../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { param } from 'jquery';
import { CommonService } from '../../../../../shared/services/common.service';
import { StorageService } from '../../../../../shared/services/storage.service';
import { ViewapproverremarksComponent } from '../../../viewapproverremarks/viewapproverremarks.component';
import { MatDialog } from '@angular/material/dialog';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';

@Component({
  selector: 'app-verify-msme-details',
  templateUrl: './verify-msme-details.component.html',
  styleUrl: './verify-msme-details.component.css'
})
export class VerifyMSMEDetailsComponent implements OnInit {
  verifyMSME: FormGroup;
  isSubmitted = false;
  paramValue: string | null = null;
  msmeInsterestList: any;
  dataSource: any;
  msmeUserId: any;
  action = false;
  status: any = [];
  nicdata: any = [];
  plandata: any = [];
  interestdata: any = [];
  filedata: any = [];
  param1: string | null = '';
  param2: string | null = '';
  showAsterisk = false; // Initially hidden
  //controlDisabled = true;

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    private commonService: CommonService,
    private storageService: StorageService,
    public dialog: MatDialog,
  ) {
    this.verifyMSME = this.formBuilder.group({
      udyamRegistrationNumber: new FormControl({ value: '', disabled: true }),
      name: new FormControl({ value: '', disabled: true }),
      gender: new FormControl({ value: '', disabled: true }),
      email: new FormControl({ value: '', disabled: true }),
      areYouAPersonWithDisabilities: new FormControl({ value: '', disabled: true }),
      ownersMobileNumber: new FormControl({ value: '', disabled: true }),
      isWhatsAppEnabled: new FormControl({ value: '', disabled: true }),
      alternateContactNumber: new FormControl({ value: '', disabled: true }),
      nameOfEnterprise: new FormControl({ value: '', disabled: true }),
      typeOfOrganization: new FormControl({ value: '', disabled: true }),
      typeOfEnterprise: new FormControl({ value: '', disabled: true }),
      officialAddressOfEnterprise: new FormControl({ value: '', disabled: true }),
      stateName: new FormControl({ value: '', disabled: true }),
      districtName: new FormControl({ value: '', disabled: true }),
      block: new FormControl({ value: '', disabled: true }),
      city: new FormControl({ value: '', disabled: true }),
      pin: new FormControl({ value: '', disabled: true }),
      dic: new FormControl({ value: '', disabled: true }),
      dateOfCommencement: new FormControl({ value: '', disabled: true }),
      dateOfIncorporation: new FormControl({ value: '', disabled: true }),
      majorActivity: new FormControl({ value: '', disabled: true }),
      investmentCost: new FormControl({ value: '', disabled: true }),
      //areYouAnExporter: new FormControl({ value: '', disabled: true }),
      //iec: new FormControl({ value: '', disabled: true }),
      status: new FormControl({ value: '', disabled: true }, Validators.required),
      remarks: [{ value: '', disabled: true }, [
        Validators.maxLength(200),
        Validators.pattern(this.commonService.descriptionPattern)
      ]],

    });
  }

  ngOnInit(): void {

    // Retrieve data from the shared service

    const { param1, param2 } = this.storageService.getTwoParams();
    //this.param1 = param1;
    //this.param2 = param2;

    if (param1 && param2) {
      // Store the parameters in sessionStorage
      sessionStorage.setItem('param1', param1);
      sessionStorage.setItem('param2', param2);
    }

    //// Retrieve the parameter value
    //this.route.params.subscribe(params => {
    //  this.msmeUserId = params['msmeuserid'];
    //  if (params['action'] == 'update') {
    //    this.action = true;
    //    this.verifyMSME.get('status')?.enable();
    //    this.verifyMSME.get('remarks')?.enable();
    //  }





    //});
    if (sessionStorage.getItem('param2') == 'update') {
      this.action = true;
      this.verifyMSME.get('status')?.enable();
      this.verifyMSME.get('remarks')?.enable();
    }

    this.msmeUserId = sessionStorage.getItem('param1')?.toString()
    this.LoadDetails(this.msmeUserId);

    this.status = [
      { id: 'Approved', text: 'Approved' },
      { id: 'Rejected', text: 'Rejected' },
      { id: 'Rejected for Query', text: 'Rejected for Query' }
    ];

    // Watch for changes in the dropdown to toggle validation on the remarks
    this.verifyMSME.get('status')?.valueChanges.subscribe(value => {
      
      const remarksControl = this.verifyMSME.get('remarks');
      if (value === 'Approved') {
        remarksControl?.clearValidators();
        this.showAsterisk = false; // Hide the asterisk
      } else if (value === 'Rejected' || value === 'Rejected for Query') {
        remarksControl?.setValidators([Validators.required, Validators.maxLength(200)]);
        this.showAsterisk = true; // Show the asterisk
      }
      remarksControl?.updateValueAndValidity();
    });

  }

  //disableFormExceptNameAndEmail(): void {
  //  // Disable all controls in the form except 'name' and 'email'
  //  Object.keys(this.verifyMSME.controls).forEach(controlName => {
  //    //this.verifyMSME.controls[controlName].disable();
  //    if (controlName !== 'name' && controlName !== 'email') {
  //      this.verifyMSME.controls[controlName].disable();
  //    }
  //  });
  //}

  //disableFormExceptNameAndEmail(): void {
  //  // Disable all controls in the form except 'name' and 'email'
  //  Object.keys(this.verifyMSME.controls).forEach(controlName => {
  //    this.verifyMSME.controls[controlName].disable();
  //  });
  //  if (this.action) {
  //    this.verifyMSME.controls['status'].enable();
  //    this.verifyMSME.controls['remarks'].enable();
  //  }
  //}

  LoadDetails(msmeuserid: string) {
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETMSMEIndividualDetails, { msmeuserid: msmeuserid }).subscribe(
      result => {
        if (result.status) {
          
          this.verifyMSME.patchValue(result.list1[0]);
          this.verifyMSME.patchValue({
            areYouAPersonWithDisabilities: result.list1[0]?.AreYouAPersonWithDisabilities ? 'Yes' : 'No',
            isWhatsAppEnabled: result.list1[0]?.isWhatsAppEnabled ? true : false,
            block: result.list1[0]?.block ? result.list1[0]?.block : 'NA',
            dateOfCommencement: result.list1[0]?.dateOfCommencement ? result.list1[0]?.dateOfCommencement : 'NA',
            dateOfIncorporation: result.list1[0]?.dateOfIncorporation ? result.list1[0]?.dateOfIncorporation : 'NA',
            alternateContactNumber: result.list1[0]?.alternateContactNumber ? result.list1[0]?.alternateContactNumber : 'NA',
            //areYouAnExporter: result.list1[0]?.areYouAnExporter ? 'Yes' : 'No',
          });
          this.nicdata = result.list2;
          this.plandata = result.list3;
          this.interestdata = result.list4;
          this.filedata = result.list5;

          if (result.list1[0]?.status == "Pending")
            this.verifyMSME.controls['status'].setValue('');


        } else {
          console.error('Failed to load user details:', result.message);
        }
      },
      error => {
        console.error('API Error:', error);
      }
    );
  }

  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }

  //LoadDetails(msmeuserid: string) {

  //  this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETMSMEIndividualDetails, { msmeuserid: msmeuserid }).subscribe(
  //    result => {
  //      if (result.status) {
  //        this.msmeInsterestList = result.data.item2;
  //        this.verifyMSME.patchValue(result.data.item1);
  //        if (result.data.item1?.status == "Pending")
  //          this.verifyMSME.controls['status'].setValue('');

  //        if (result.data.item1?.gender == "male")
  //          this.verifyMSME.controls['gender'].setValue('Male');
  //        else if (result.data.item1?.gender == "female")
  //          this.verifyMSME.controls['gender'].setValue('Female');
  //        else
  //          this.verifyMSME.controls['gender'].setValue('Other');



  //        if (result.data.item1['isWhatsAppEnabled']) {
  //          this.setCheckboxValues(true);
  //        } else {
  //          this.setCheckboxValues(false);
  //        }
  //      }
  //    }
  //  )
  //}

  setCheckboxValues(condition: boolean) {
    this.verifyMSME.patchValue({
      isWhatsAppTrue: condition,
      isWhatsAppFalse: !condition
    });
  }

  submit() {
    if (this.verifyMSME.valid) {
      
      const statusBy = sessionStorage.getItem('mssidcuserid');
      const msmeUserId = this.msmeUserId
      
      var formData = {
       ...this.verifyMSME.value,
        msmeUserId,
        statusBy,
        
      };
      
      this.apiService.postRequest(API_ENDPOINTS.MSSIDC.POSTMSMEUpdate, formData,).subscribe(
        res => {
          if (res.status) {
            this.toastr.success(res.message);
            this.router.navigate(['/msmeverification']);

          }
          else {
            this.toastr.error(res.message);
            this.router.navigate(['/msmeverification']);
          }
        }
      );
    }
  }

  cancel() {
    this.verifyMSME.get('status')?.setValue('');
    this.verifyMSME.get('remarks')?.setValue('');
  }

  back() {
    this.router.navigate(['/msmeverification']);
  }

  ViewStatusHistory() {
    const dialogRef = this.dialog.open(ViewapproverremarksComponent, {
      width: '600px',
      data :{ msmeUserId : this.msmeUserId}
    });

    dialogRef.afterClosed().subscribe(result => { });

  }

  openFilePreviewDialog(filePath: string, fileName: string): void {
    //var filePath = this.form.get('documentPath')?.value;
    //var fileName = this.form.get('documentName')?.value;

    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }
}
